import { Component, OnInit,AfterViewInit } from '@angular/core';
import {FormGroup,FormBuilder,Validators} from '@angular/forms';
import {DataService} from '../data.service';
import {HomeComponent} from '../home/home.component';
declare var $:any;

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.css']
})
export class EnterpriseComponent implements OnInit,AfterViewInit {
  enterpriseForm:FormGroup;
  isNext:boolean=false;
  userTypeId:number=-1;
  planId:number=-1;
  constructor(private service:DataService,private fb:FormBuilder,private home:HomeComponent) {
    this.enterpriseForm=this.fb.group({
      'full_name':['',Validators.required],
      'org':['',Validators.required],
      'email':['',Validators.compose([Validators.required,Validators.email])],
      'phno':['',Validators.compose([Validators.required,Validators.pattern("^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$")])],
    })

   }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
  }

  ngAfterViewInit(){
      $(window).scrollTop(0);
    $('.cd-header').css('background-color','#931346');
  }

  submitEnterprise(form){
    this.validateForm(form);
    if(!form.valid){
      if(!form.controls['full_name'].valid){
        this.service.alertMessage('Please enter the full name','error');
        return false;
      }
      if(!form.controls['org'].valid){
        this.service.alertMessage('Please enter your organisation','error');
        return false;
      }
      if(!form.controls['email'].valid){
        if(form.controls['email'].hasError('required')){
            this.service.alertMessage('Please enter your email','error');
            return false;
        }
        if(form.controls['email'].hasError('email')){
          this.service.alertMessage('Invalid email format','error');
          return false;
        }
      }

      if(!form.controls['phno'].valid){
        if(form.controls['phno'].hasError('required')){
            this.service.alertMessage('Please enter your phno','error');
            return false;
        }
        if(form.controls['phno'].hasError('pattern')){
          this.service.alertMessage('Invalid phno format','error');
          return false;
        }
      }
    } else {
      const inputJson={
    	"Email":form.controls['email'].value,
    	"FullName":form.controls['full_name'].value,
    	"Oraganization":form.controls['org'].value,
    	"Phone":form.controls['phno'].value
    }
   // console.log(inputJson);
    this.service.RequestForEnterprise(inputJson)
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
          this.enterpriseForm.reset();
          this.service.alert('Thank You for your interest. We will connect pronto!','success');

        } else {
          this.service.alert(result['Message'],'error')
        }
      },
      (error)=>{
        console.log(error);
      }
    )
    }
  }

  validateForm(form:FormGroup){
    (<any>Object).values(form.controls).forEach(control=>{
      control.markAsTouched();
      if(control.controls){
        control.controls.forEach(c=>{
          this.validateForm(c);
        })
      }
    })
  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/enterprise/enterprise.component.ts